import axios, { AxiosRequestConfig } from 'axios'
import qs from 'qs'
import { getStorage } from '.'
import { TOKENKEY } from '@/config/constant'
import { requestErrorHandle } from './error-handle'

const gloableHeaderConfig: Record<string, unknown> = {}
declare module 'axios' {
  interface AxiosInstance {
    (config: AxiosRequestConfig): Promise<{
      data: Record<string, unknown>
      message: string
      status: number
    }>
  }
}

const instance = axios.create({
  timeout: 60 * 1000, //
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    token: getStorage(TOKENKEY) as string,
  },
})

// Request interceptors
instance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    if (config.method?.toLocaleLowerCase() === 'post') {
      const headers = config.headers
      console.log('headers', headers)
      if (headers && headers['Content-Type'] === FormDataHeader['Content-Type']) {
        config.data = qs.stringify(config.data)
      }
    }
    // console.log('config', config)
    Object.assign(config.headers, gloableHeaderConfig)
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

const whiteSpace = ['/api-invoice/common/qiniu/oauth_up_token']
// Response interceptors
instance.interceptors.response.use(
  (response) => {
    const res = response.data
    // 兼容下培训系统
    res.status = res.status_code || res.status
    if (res.status) {
      if (res.status === 200) {
        if (response.config.headers.getResponseData === '1') {
          return Promise.resolve(res)
        }
        return Promise.resolve(res.data)
      } else {
        return Promise.reject(res)
      }
    } else {
      if (whiteSpace.includes(response.config.url)) {
        if (response.data && response.data.status === undefined) {
          return Promise.resolve(res)
        } else {
          return Promise.reject(res)
        }
      }
      return Promise.reject(res)
    }
    // if (res.status && res.status !== 200) {
    //   if (res.status === 401 || res.status === 3004) {
    //     if (!router.currentRoute.query.redirect) {
    //       router.push(`/login?redirect=${router.currentRoute.fullPath}`)
    //     }
    //   } else {
    //     Message({
    //       message: res.message || 'Error',
    //       type: 'error',
    //       duration: 2 * 1000,
    //       showClose: true,
    //     })
    //   }
    //  应该是服务器请求正常200，但是后端代码能够返回非200的其他错误，这仅仅代表请求成功了，但有可能没权限啊、少了参数等等
    //  错误信息存在于message
    // return Promise.resolve(res)
    // }
  },
  (error) => {
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000,
    // })
    // 服务器500报错
    error.response && requestErrorHandle(error) // axios的超时错误不会有response
    const errorObj = error?.response?.data || error
    console.log('error', error, 'errorObj', errorObj)
    return Promise.reject(errorObj)
  }
)

export const FormDataHeader = {
  'Content-Type': 'application/x-www-form-urlencoded',
}

/**
 * 设置全局的token
 * @param {*} key
 * @param {*} value
 */
export function setGlobelHeader(key: string, value: unknown): void {
  gloableHeaderConfig[key] = value
}
// 获取全局Header对应的key value
export function getGlobelHeader(key: string): unknown {
  return gloableHeaderConfig[key]
}
export default instance
